// extracted by mini-css-extract-plugin
export default {"homeContainer":"Home_homeContainer__mfaS8","projectsContainer":"Home_projectsContainer__Pw4+-","previews":"Home_previews__6N6Pq","bottomHome":"Home_bottomHome__uFzS0"};